// extracted by mini-css-extract-plugin
module.exports = {"suggests":"_025a50318d--suggests--1OKB6","suggest":"_025a50318d--suggest--2rKVa"};